import { UAParser } from "ua-parser-js";

/**
 * ヘッダーからユーザーエージェントを取得しモバイル端末を判定する
 * @returns bool
 */
export default function useIsMobile() {
  const headers = useRequestHeaders();
  const ua = new UAParser(headers["user-agent"]).getResult();
  return ua.device.type === "mobile";
}
